import { publicInstance } from '@/api/axiosInstance';
import { PECAI_API_URL } from '..';
import {
  PecaAiOrderDetailRequest,
  PecaAiOrderDetailResponse,
} from './orders.types';
import pecaAiServices from '../../enterprise/pecaAi/pecaAi.services';

const CONTROLLER = `${PECAI_API_URL}/buyers`;

export default {
  async orderDetail(params: PecaAiOrderDetailRequest) {
    const token = await pecaAiServices.getToken();

    const response = await publicInstance.get<PecaAiOrderDetailResponse>(
      `${CONTROLLER}/${params.document}/orders/${params.orderId}`,
      {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      },
    );

    return response.data;
  },
};
